import React, { useState, useEffect } from "react";
import { useLanguageContext } from "../../../context/languageContext";
import Button from "../../buttons/Button";
import enUS from "../../../data/en-US";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from "react-redux";
import { getUserById } from "actions/contributor/homeActions";
import { Link } from "react-router-dom";

const ContributorSection = () => {
    const dispatch = useDispatch();
    // pull the language provider and pull the content data
    const { language } = useLanguageContext();
    const [ data, setData ] = useState();

    const info = {
        'en-US': enUS
    }

    useEffect(() => {
        setData(info[language].homepage.contributors)
    }, [])

    // pull the user info from cookie
    const userCookie = Cookies.getJSON('userInfo') || null;
    
    // get the logged in user by id
    const signedinUser = useSelector(state => state.signedinUser.userInfo)
    useEffect(() => {
        userCookie && dispatch(getUserById(userCookie.id))
    }, [])
    
    //check if the role of the logged in user is contributor
    const [ isContributor, setIsContributor ] = useState(false)
    const contributorRoleArray = [3, 4, 5, 6, 7, 8]
    useEffect(() => {
        signedinUser && 
            contributorRoleArray.filter(p => p === signedinUser.role_id).length > 0 ? setIsContributor(true) : setIsContributor(false)
    }, [signedinUser])


    return (
        <div className="text-center contributor-section">
            <div className="themesflat-container">
                <div className="contributor-section-heading font-face-pop">
                    { data && data.heading }
                </div>
                <div className="contributor-section-body font-face-poppins">
                    <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-10">
                            { data && data.body }
                        </div>
                        <div className="col-md-1"></div>
                    </div>
                </div>
                {
                    !isContributor && (
                        <Link to={'/contributor-register'}>
                            <Button 
                                text={ data && data.button }
                                width={250}
                                height={50}
                                borderRadius={10}
                            />
                        </Link>
                    )
                }
            </div>
        </div>
    )

}

export default ContributorSection;